import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { InputMask } from "@react-input/mask";

const Organizations = () => {
	const [organizations, setOrganizations] = useState([]);
	const [loading, setLoading] = useState(true);
	const [addShow, setAddShow] = useState(false);
	const [successShow, setSuccessShow] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [organisationName, setOrganisationName] = useState("");
	const [organisationMail, setOrganisationMail] = useState("");
	const [organisationPhone, setOrganisationPhone] = useState("");
	const [organisationAuthorizedPerson, setOrganisationAuthorizedPerson] = useState([""]);
	const [organisationFloors, setOrganisationFloors] = useState("");
	const [organisationRooms, setOrganisationRooms] = useState("");
	const [organisationBilling, setOrganisationBilling] = useState("");
	const [organisationAuthorizedPersonActive, setOrganisationAuthorizedPersonActive] = useState("Aktif");
	const [organisationActive, setOrganisationActive] = useState("Aktif");

	const tableHeaders = [
		"",
		"Kurum Adı",
		"Kat Sayısı",
		"Oda Sayısı",
		"",
	];

	const getOrganizations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const organizationsData = await response.json();
			setOrganizations(organizationsData);
			setLoading(false);
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
			setLoading(false);
		}
	};

	useEffect(() => {
		getOrganizations();
	}, []);

	const addHandleClose = () => {
		setAddShow(false);
		// Form alanlarını temizle
		setOrganisationName("");
		setOrganisationMail("");
		setOrganisationPhone("");
		setOrganisationAuthorizedPerson([""]);
		setOrganisationFloors("");
		setOrganisationRooms("");
		setOrganisationBilling("");
		setOrganisationAuthorizedPersonActive("Aktif");
		setOrganisationActive("Aktif");
	};

	const addHandleShow = () => setAddShow(true);

	const handleSuccess = () => {
		setSuccessShow(false);
		getOrganizations();
	};

	const addOrganization = async (e) => {
		e.preventDefault();

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch("https://app.vivasmartcare.com/api/add-organisation", {
				method: "POST",
				body: JSON.stringify({
					organisationName,
					organisationMail,
					organisationPhone,
					organisationAuthorizedPerson,
					organisationFloors,
					organisationRooms,
					organisationBilling,
					organisationAuthorizedPersonActive,
					organisationActive,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				setSuccessShow(true);
				addHandleClose();
				getOrganizations();
			} else {
				alert("Kurum eklenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Ekleme işlemi sırasında bir hata oluştu:", error);
			alert("Kurum eklenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	return (
		<Layout>
			<div className="organizations-wrapper">
				<div className="device-table-wrapper">
					<div className="device-filter-inputs">
						<Form.Group>
							<Button variant="primary" onClick={addHandleShow}>
								Kurum Ekle
							</Button>
						</Form.Group>
					</div>
					<Table striped bordered hover responsive className="alarm-table">
						<thead>
							<tr>
								{tableHeaders.map((header, index) => (
									<th key={index}>{header}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan={tableHeaders.length} style={{ textAlign: "center" }}>
										<Spinner animation="border" variant="primary" />
									</td>
								</tr>
							) : organizations && organizations.length > 0 ? (
								organizations.map((org, index) => (
									<tr key={org._id || index}>
										<td className="table-id">{index + 1}</td>
										<td>{org.organisationName || "-"}</td>
										<td>{org.organisationFloors || "-"}</td>
										<td>{org.organisationRooms || "-"}</td>
										<td>
											<Link to={`/organizations/${org._id}`}>Düzenle</Link>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={tableHeaders.length} style={{ textAlign: "center" }}>
										Henüz kurum bulunmamaktadır.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</div>
			<Modal show={addShow} onHide={addHandleClose}>
				<Modal.Header>Kurum Bilgisi Ekle</Modal.Header>
				<Modal.Body className="device-add-wrapper">
					<Form onSubmit={addOrganization}>
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="Kurum Adı Giriniz"
								value={organisationName}
								required
								onChange={(e) => setOrganisationName(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="email"
								placeholder="E-posta Adresi Giriniz"
								value={organisationMail}
								onChange={(e) => setOrganisationMail(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<InputMask
								mask="+90__________"
								replacement={{ _: /\d/ }}
								value={organisationPhone}
								showMask
								onChange={(e) => setOrganisationPhone(e.target.value)}
								className="form-control"
								placeholder="Telefon No Giriniz"
							/>
						</Form.Group>
						<Form.Group>
							<label>Yetkili Kişi:</label>
							{organisationAuthorizedPerson.map((person, index) => (
								<div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
									<Form.Control
										type="text"
										placeholder="Yetkili Kişi Adı Giriniz"
										value={person}
										onChange={(e) => {
											const newPersons = [...organisationAuthorizedPerson];
											newPersons[index] = e.target.value;
											setOrganisationAuthorizedPerson(newPersons);
										}}
										style={{ flex: 1 }}
									/>
									{organisationAuthorizedPerson.length > 1 && (
										<Button
											variant="danger"
											size="sm"
											type="button"
											onClick={() => {
												const newPersons = organisationAuthorizedPerson.filter((_, i) => i !== index);
												setOrganisationAuthorizedPerson(newPersons);
											}}
										>
											Sil
										</Button>
									)}
								</div>
							))}
							<Button
								variant="outline-secondary"
								size="sm"
								type="button"
								onClick={() => setOrganisationAuthorizedPerson([...organisationAuthorizedPerson, ""])}
								style={{ marginTop: "10px" }}
							>
								+ Yetkili Kişi Ekle
							</Button>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="number"
								placeholder="Kat Sayısı Giriniz"
								value={organisationFloors}
								required
								onChange={(e) => setOrganisationFloors(e.target.value)}
								min="1"
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="number"
								placeholder="Oda Sayısı Giriniz"
								value={organisationRooms}
								required
								onChange={(e) => setOrganisationRooms(e.target.value)}
								min="1"
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="Faturalama Bilgisi Giriniz"
								value={organisationBilling}
								onChange={(e) => setOrganisationBilling(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Form.Select
								value={organisationAuthorizedPersonActive}
								onChange={(e) => setOrganisationAuthorizedPersonActive(e.target.value)}
							>
								<option value="Aktif">Yetkili Kişi Durumu: Aktif</option>
								<option value="Pasif">Yetkili Kişi Durumu: Pasif</option>
							</Form.Select>
						</Form.Group>
						<Form.Group>
							<Form.Select
								value={organisationActive}
								onChange={(e) => setOrganisationActive(e.target.value)}
							>
								<option value="Aktif">Kurum Durumu: Aktif</option>
								<option value="Pasif">Kurum Durumu: Pasif</option>
							</Form.Select>
						</Form.Group>
						<div className="button-wrapper">
							<Button variant="secondary" onClick={addHandleClose}>
								İptal
							</Button>
							<Button
								variant="primary"
								type="submit"
								disabled={btnDisabled}
							>
								Ekle
							</Button>
							{showSpinner && <Spinner animation="border" variant="primary" />}
						</div>
					</Form>
				</Modal.Body>
			</Modal>
			<Modal show={successShow} onHide={handleSuccess}>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>Kurum Başarıyla Eklendi.</Modal.Body>
			</Modal>
		</Layout>
	);
};

export default Organizations;

